package hk.com.vr360_demo2.webapp.core.di

import hk.com.vr360_demo2.webapp.core.net.KtorPublicApi
import hk.com.vr360_demo2.webapp.core.net.httpClient
import io.ktor.client.*
import io.ktor.client.engine.js.*
import org.koin.core.module.Module
import org.koin.dsl.module

val appModule: Module = module {
    single { httpClient }
    single { KtorPublicApi(get()) }
}

